const columnStrategies = {
  assigned_to: {
    prepareData: function (value) {
      return { assigned_to: value.id };
    },
    getDisplayValue: function (value) {
      return value.username;
    },
  },
  // Добавить новые поля
};

// Функция для подготовки данных для запроса
export function prepareRequestData(columnId, newValue) {
  if (columnStrategies[columnId]) {
    return columnStrategies[columnId].prepareData(newValue);
  }
  return { [columnId]: newValue };
}

// Функция для подготовки данных для отображения
export function getDisplayValue(columnId, newValue) {
  if (columnStrategies[columnId]) {
    return columnStrategies[columnId].getDisplayValue(newValue);
  }
  return newValue;
}
